import { gql } from '@apollo/client';
import {
  PLAYER_INFO_FRAGMENT,
  PLAYER_STATS_FRAGMENT,
  SCHEDULE_FRAGMENT,
} from '../../fragments';

export const GET_TEAM_INFO = gql`
  ${PLAYER_INFO_FRAGMENT}
  ${PLAYER_STATS_FRAGMENT}
  ${SCHEDULE_FRAGMENT}
  query GetPlayersByTeam($teamId: Int!, $seasonId: Int!) {
    teams(where: { id: { _eq: $teamId } }) {
      champion
      color
      colorSecondary
      division
      name
      captainPlayer {
        firstName
        lastName
        id
      }
      rosters {
        players {
          ...PlayerInfo
        }
      }
      seasonBySeason {
        id
        season
        year
        league
        schedules(where: { seasonId: { _eq: $seasonId } }) {
          ...ScheduleFragment
        }
      }
    }
    players(
      where: {
        _or: [
          { positionSecondary: { _eq: GOALIE } }
          { position: { _eq: GOALIE } }
        ]
        rosters: { teamId: { _eq: $teamId } }
      }
    ) {
      id
      position
      firstName
      lastName
      jersey
      jerseySecondary
    }
  }
`;
